<script>
    import Header from "./Header.svelte";
    import StepOne from "./forms/step-one/StepOne.svelte";
    import StepTwo from "./forms/step-two/StepTwo.svelte";
    import StepThree from "./forms/step-three/StepThree.svelte";
    import InitForm from "./forms/InitForm.svelte";


    let currentStep = {step: 0};

    function nextStep() {
        currentStep.step++;
    }

    function firstStep() {
        currentStep.step = 1;
    }
</script>
<main class="container">

    <div class="header">
        <Header/>
    </div>

    <div class="wrapper">

        {#if currentStep.step === 0}
          <InitForm on:nextStep={nextStep} />
        {/if}

        {#if currentStep.step === 1}
            <StepOne on:nextStep={nextStep}/>
        {/if}
        {#if currentStep.step === 2}
            <StepTwo on:nextStep={nextStep}/>
        {/if}
        {#if currentStep.step === 3}
            <StepThree on:nextStep={nextStep} on:restart={firstStep}/>
        {/if}

    </div>
</main>

<style>

    :global(body) {
        color: #242424;
        background-color: #ededed !important;
    }

    .header {
        background-color: white;
        margin: 2rem auto 0;
        max-width: 900px;
        padding: 0.5rem 2rem;
        box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
        border-radius: 8px;
    }

    .wrapper {
        background-color: white;
        margin: 2rem auto;
        max-width: 900px;
        padding: 2rem;
        box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
        border-radius: 8px;
    }
</style>